import { Component, ViewEncapsulation } from '@angular/core';
import { FieldTypeConfig, FormlyFieldConfig } from '@ngx-formly/core';
import { FormlyFieldSelectProps } from '@ngx-formly/core/select';
import { FieldTypeDirective } from '../form-field-wrapper/field.type.directive';
import { Observable, of } from 'rxjs';
import { constant } from 'lodash';

interface SelectBoxProps extends FormlyFieldSelectProps {
  multiple?: boolean;
  tooltips?: { text: string }[];
  readonly: boolean;
  beforeSelect?(field: FormlyFieldConfig): Observable<boolean>;
  columns?: 1 | 2 | 3;
}

@Component({
    selector: 'lockton-apps-select-box-type',
    templateUrl: './select-box-type.component.html',
    styleUrls: ['./select-box-type.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class SelectBoxTypeComponent extends FieldTypeDirective<
  FieldTypeConfig<SelectBoxProps>
> {
  get columns() {
    return this.props.columns || 3;
  }

  get beforeSelect(): () => Observable<boolean> {
    return this.props.beforeSelect
      ? this.props.beforeSelect.bind(null, this.field)
      : constant(of(true));
  }
}
